import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import {
  LOCAL_STORAGE_KEYS,
  LOCAL_STORAGE_SELECTED_TEAM_ID_NO_ORG,
  URL_CONTEXTS
} from 'common/constants/constants';
import { connectPusher } from 'common/services/pusher.service';
import { subscribeToEvent } from 'common/services/pusher.subscribers';
import { PUSHER_EVENTS } from '@linearb/linjs-common';

const resolveTeamContext = organization => {
  const urlParams = new URLSearchParams(window.location.search);
  const context = urlParams.get('context');
  const localStorageAccessor = BrowserStorageAccessor(organization.id).local;
  switch (context) {
    case URL_CONTEXTS.ORGANIZATION: {
      localStorageAccessor.remove(LOCAL_STORAGE_KEYS.SELECTED_TEAM_ID);
      break;
    }
    case URL_CONTEXTS.TEAM:
    case URL_CONTEXTS.TEAM_ITERATION: {
      const teamId = urlParams.get('teams');
      if (teamId) {
        localStorageAccessor.set(LOCAL_STORAGE_KEYS.SELECTED_TEAM_ID, teamId);
      }
      break;
    }
    default:
      break;
  }
};

export const handleActiveTeam = (organization, selectTeamId) => {
  resolveTeamContext(organization);

  const storedTeamId = BrowserStorageAccessor(organization.id).local.get(
    LOCAL_STORAGE_KEYS.SELECTED_TEAM_ID
  );

  if (storedTeamId) {
    const storedTeamIdAsNumber = parseInt(storedTeamId);
    selectTeamId(storedTeamIdAsNumber);
    return storedTeamIdAsNumber;
  }

  // if teamId not found in localStorage > ORG#_selected_team_id, check key _selected_team_id
  const storedTeamIdNoOrg = localStorage.getItem(
    LOCAL_STORAGE_SELECTED_TEAM_ID_NO_ORG
  );

  if (storedTeamIdNoOrg) {
    const storedTeamIdAsNumber = parseInt(storedTeamIdNoOrg);
    selectTeamId(storedTeamIdAsNumber);
    return storedTeamIdAsNumber;
  }
};

export function initPusher(account, configuration) {
  if (account.organization_id && configuration) {
    const { pusher_app_key, pusher_cluster } = configuration;
    try {
      connectPusher(pusher_app_key, pusher_cluster, account.organization_id);
      subscribeToEvent(PUSHER_EVENTS.ADD_REPOSITORIES);
    } catch (err) {
      window.TrackJS &&
        window.TrackJS.console.error(
          'Pusher error on subsbsctibe to event',
          err
        );
    }
  }
}
